import React, { useState, useEffect } from 'react';

import './index.css';

interface Props {
    title: React.ReactNode,
    titleSecondary?: string,
    visible: boolean,
    iconNormal?: boolean,
    onChange?: Function,
    getValue?: Function,
    expandAll?: boolean,
    closeAll?: boolean,
}

const LcAccordionAlt: React.FC<Props> = (props) => {
    const [visible, setVisible] = useState<boolean>(props.visible);

    const handleVisible = () => {
        setVisible(!visible)
        if (props.getValue) props.getValue(!visible);
    }

    useEffect(() => {
        if (props.expandAll) {
            setVisible(true);
        }
    }, [props.expandAll])

    useEffect(() => {
        if (props.closeAll) {
            setVisible(false);
        }
    }, [props.closeAll])

    return (
        <div className={`lc-accordionAlt ${visible ? '' : 'visible'}`}>
            <div className="header" onClick={() => handleVisible()}>
                <div className="title">{props.title}</div>
                {
                    props.titleSecondary &&
                    <span className={"titleSecondary"}>{props.titleSecondary}</span>
                }
                <i className={"ppi ppi-chevron-down"} style={{ marginLeft: "20px" }} />
            </div>
            {
                visible &&
                <div className={`body ${!visible ? 'hide' : ''}`}>
                    {props.children}
                </div>
            }
        </div>
    );
}

export default LcAccordionAlt;